// Drawer sample
customElements.define(
  "drawer-samples",
  class DrawerSample extends HTMLElement {
    constructor() {
      super();

      let selectors = {
        updateSamplesTrigger: "[data-item-samples-update]",
        updateSamplesPanel: "[data-item-samples-panel]",
        updateSamplesPanelClose: "[data-item-samples-panel-close]",
        updateSamplesPanelItem: "[data-item-samples-panel-item]",
        updateSamplesPanelItemId: "itemSamplesPanelItemVariant",
        updateSamplesPanelChange: "[data-item-samples-panel-change]",
        updateSamplesPanelItemIndex: "[data-item-samples-panel-item-index]",
        updateSamplesPanelItemSelecteds: "[data-item-samples-panel-selected]",
        updateSamplesPanelCountMax: "itemSamplesCount",
        dataRemoveSamplesItem: "[data-remove-samples-item]",
      };

      this.selectors = selectors;
      this.samples_ids = [];
      this.old_samples_ids = [];

      this.init();
    }

    async getCart() {
      return await fetch(`/cart.js`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      })
      .then(response => response.json())
      .then(data => {
        data.progress_bar_excluded_item = 7379504758948
        const excludedItems = data.progress_bar_excluded_item
        const cartItems = data.items
        
        cartItems.forEach((item) => {
          if(item.product_id == excludedItems){
            data.total_price = parseInt(data.total_price - item.final_line_price);
          }
        })
        return data;
      })
      .catch(error => console.error('Error getting cart:', error));
    }

    async init() {
      this.updateSamplesTrigger = this.querySelector(
        this.selectors.updateSamplesTrigger
      );
      this.updateSamplesPanel = document.querySelector(
        this.selectors.updateSamplesPanel
      );
      this.updateSamplesPanelClose = document.querySelector(
        this.selectors.updateSamplesPanelClose
      );
      this.updateSamplesPanelItems = document.querySelectorAll(
        this.selectors.updateSamplesPanelItem
      );
      this.updateSamplesPanelChange = document.querySelector(
        this.selectors.updateSamplesPanelChange
      );
      this.dataRemoveSamplesItem = this.querySelector(
        this.selectors.dataRemoveSamplesItem
      );
      this.updateSamplesPanelItemSelecteds = document.querySelectorAll(
        this.selectors.updateSamplesPanelItemSelecteds
      );
      this.updateSamplesPanelCountMax =
        this.updateSamplesTrigger.dataset[
          this.selectors.updateSamplesPanelCountMax
        ];

      this.samples_ids = [];
      this.old_samples_ids = [];

      const cart = await this.getCart();

      for (let index = 0; index < cart.items.length; index++) {
        if (cart.items[index].properties != null) {
          if ("_is_sample" in cart.items[index].properties) {
            this.old_samples_ids.push({
              variant_id: cart.items[index].variant_id,
              key: cart.items[index].key,
              quantity: cart.items[index].quantity,
            });

            this.samples_ids.push({
              variant_id: cart.items[index].variant_id,
              quantity: cart.items[index].quantity,
            });
          }
        }
      }

      if (cart.total_price == 0) {
        if (this.old_samples_ids.length != 0) {
          var dataUpdate = {};
          dataUpdate.updates = {};
          for (let index = 0; index < this.old_samples_ids.length; index++) {
            dataUpdate.updates[this.old_samples_ids[index].key] = 0;
          }
          await this.updateItems(dataUpdate);
        }
      }

      this.updateSamplesTrigger.addEventListener("click", (event) => {
        this.open();
      });

      this.dataRemoveSamplesItem.addEventListener("click", async (event) => {
        if (this.old_samples_ids.length != 0) {
          var dataUpdate = {};
          dataUpdate.updates = {};
          for (let index = 0; index < this.old_samples_ids.length; index++) {
            dataUpdate.updates[this.old_samples_ids[index].key] = 0;
          }
          await this.updateItems(dataUpdate);
          document.dispatchEvent(
            new CustomEvent("elkad:cart:add", { bubbles: !0 })
          )
        }
      });

      this.initPanel();
    }

    initPanel() {
      if (this.updateSamplesPanel.classList.contains("initialized")) return;

      this.updateSamplesPanelItemSelecteds.forEach((updateSamplesPanelItemSelected) => {
        updateSamplesPanelItemSelected.innerHTML = this.old_samples_ids.length + "/" + this.updateSamplesPanelCountMax;
      });
      
      this.updateSamplesPanelClose.addEventListener("click", (event) => {
        this.close();
      });

      this.updateSamplesPanelItems.forEach((updateSamplesPanelItem) => {
        updateSamplesPanelItem.addEventListener("click", (event) => {
          this.selectItem(updateSamplesPanelItem);
        });
      });

      var self = this;
      this.updateSamplesPanelChange.addEventListener(
        "click",
        async function (event) {
          self.updateSamplesPanelChange.setAttribute("disabled", "");
          localStorage.setItem("samplesAdded", true);

          if (self.old_samples_ids.length != 0) {
            var dataUpdate = {};
            dataUpdate.updates = {};
            for (let index = 0; index < self.old_samples_ids.length; index++) {
              dataUpdate.updates[self.old_samples_ids[index].key] = 0;
            }
            await self.updateItems(dataUpdate);
          }

          if (self.samples_ids.length != 0) {
            var dataAdd = {};
            dataAdd.items = [];
            for (let index = 0; index < self.samples_ids.length; index++) {
              dataAdd.items.push({
                id: self.samples_ids[index].variant_id,
                quantity: 1,
                properties: {
                  _is_sample: true,
                  _sample_id: self.samples_ids[index].variant_id,
                },
              });
            }
            await self.addItems(dataAdd);
          }

          self.close();
          document.dispatchEvent(
            new CustomEvent("elkad:cart:add", { bubbles: !0 })
          )
        }
      );

      this.updateSamplesPanel.classList.add("initialized");
    }

    open() {
      this.updateSamplesPanel.classList.add("active");

      if (this.samples_ids.length != 0) {
        for (let index = 0; index < this.samples_ids.length; index++) {
          this.updateSamplesPanelItems.forEach((updateSamplesPanelItem) => {
            if (
              updateSamplesPanelItem.dataset[
                this.selectors.updateSamplesPanelItemId
              ] == this.samples_ids[index].variant_id
            ) {
              updateSamplesPanelItem.classList.add("active");
              updateSamplesPanelItem.querySelector(
                this.selectors.updateSamplesPanelItemIndex
              ).innerHTML = index + 1;
            }
          });
        }
      }
    }

    close() {
      this.updateSamplesPanel.classList.add("close");
      this.updateSamplesPanel.classList.remove("active");
      this.updateSamplesPanelChange.removeAttribute("disabled");
      setTimeout(() => this.updateSamplesPanel.classList.remove("close"), 1000);
    }

    selectItem(updateSamplesPanelItem) {
      if (updateSamplesPanelItem.classList.contains("active")) {
        updateSamplesPanelItem.classList.remove("active");
        for (let index = 0; index < this.samples_ids.length; index++) {
          if (
            updateSamplesPanelItem.dataset[
              this.selectors.updateSamplesPanelItemId
            ] == this.samples_ids[index].variant_id
          ) {
            this.samples_ids.splice(index, 1);
          }
        }

        this.updateSamplesPanelItems.forEach((updateSamplesPanelItem) => {
          if (updateSamplesPanelItem.classList.contains("active")) {
            for (let index = 0; index < this.samples_ids.length; index++) {
              if (
                updateSamplesPanelItem.dataset[
                  this.selectors.updateSamplesPanelItemId
                ] == this.samples_ids[index].variant_id
              ) {
                updateSamplesPanelItem.querySelector(
                  this.selectors.updateSamplesPanelItemIndex
                ).innerHTML = index + 1;
              }
            }
          }
        });
      } else if (
        this.samples_ids.length <=
        this.updateSamplesPanelCountMax - 1
      ) {
        updateSamplesPanelItem.classList.add("active");
        updateSamplesPanelItem.querySelector(
          this.selectors.updateSamplesPanelItemIndex
        ).innerHTML = this.samples_ids.length + 1;
        this.samples_ids.push({
          variant_id:
            updateSamplesPanelItem.dataset[
              this.selectors.updateSamplesPanelItemId
            ],
          quantity: 1,
        });
      }

      this.updateSamplesPanelItemSelecteds.forEach(
        (updateSamplesPanelItemSelected) => {
          updateSamplesPanelItemSelected.innerHTML =
            this.samples_ids.length + "/" + this.updateSamplesPanelCountMax;
        }
      );
    }

    async addItems(data) {
      const result = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          return response.text();
        })
        .then(async function (state) {})
        .catch(() => {});
    }

    async updateItems(data) {
      const result = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {})
        .catch(() => {});
    }
  }
);

document.addEventListener("elkad:cart:built", async (e) => {
  // Reload the component
  const drawerSamples = document.querySelector("drawer-samples");
  drawerSamples.init();
});